
import Vue from 'vue';
import {
  HotspotSimpleAuthorItemComputed,
  HotspotSimpleAuthorItemProps,
} from '@owc-packages/Hotspot/src/HotspotSimpleItem.d';
import { calculateSimpleItemTooltipPosition } from '@owc-packages/Hotspot/src/HotspotUtils';
import ValidationBoxWrapper from '@owc-packages/ValidationBox/src';

export default Vue.extend<{}, {}, HotspotSimpleAuthorItemComputed, HotspotSimpleAuthorItemProps>({
  name: 'owc-hotspot-simple-author-item',
  components: {
    ValidationBoxWrapper,
  },
  props: {
    item: {
      type: Object,
      required: true,
    },
  },
  computed: {
    tooltipPosition() {
      return calculateSimpleItemTooltipPosition(this.item);
    },
  },
});
